import {useListView} from '../../core/ListViewProvider'
import {ChatListToolbar} from './UserListToolbar'
import {ChatListGrouping} from './UsersListGrouping'
import {ChatListSearchComponent} from './UsersListSearchComponent'

const ChatListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <ChatListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <ChatListGrouping /> : <ChatListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {ChatListHeader}
